import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PasswordResetRouteComponent } from '../../reset-password';

export const Route = createFileRoute('/_unauth/account/activate/')({
    component: PasswordResetRouteComponent,
    validateSearch: z.object({
        UserId: z.string().optional(),
        Code: z.string().optional(),
    }),
});
